import { fetchApi } from "@/lib/api/index.ts";
import { UserRole } from "@/lib/api/user.ts";

interface AuthenticateImpersonationResponse {
  session_token: string;
  session_jwt: string;
  user: {
    id: string;
    name: string;
    role: UserRole;
  };
}

export const authenticateImpersonationToken = async (
  impersonationToken: string,
) => {
  const response = await fetchApi<AuthenticateImpersonationResponse>(
    {
      url: "/v2/impersonation/authenticate",
      method: "POST",
      data: { impersonation_token: impersonationToken },
    },
    false,
  );

  return response.data;
};
